import { gql } from "@apollo/client";

export const GET_INITIATIVES_BY_ORG = gql`
  query GetInitiativesByOrgId($orgId: String) {
    getInitiativesByOrgId(orgId: $orgId) {
      address
      description
      id
      images
      name
      organizationId
      serviceId
      joinDate
      organizations {
        id
        name
        logoUrl
      }
      service {
        id
        name
        location {
          city
          country
          name
          address
        }
      }
    }
  }
`;
